import { OrderForm } from './orderForm';
import { User } from './user';
import { TaxData } from './taxData';
import {Coupon} from "./coupon";

export class State {
  pageName?: string;
  navParams?: any;
  orderDetails?: any;
  funnel?: OrderForm;
  coupon?: Coupon;
  date?: number;
  accountDetails?: User;
  taxData?: TaxData;
  bumpExpireList?: Array<{
    sfid: string,
    viewDate?: any,
  }>;
  upsells?: any;
  enableAsync?: boolean;
  pendingAsyncOrdersByMainOrderId?: { [mainOrderId: string]: Array<{ asyncOrderId: string; productName: string; quantity: number }> };
  shippingInfo?: {
    accountInfoForShipping: User,
    productsForShipping: any,
    selectedDeliveryDay?: any,
    isValid: boolean,
  }
}
